import { render, staticRenderFns } from "./appInfoDetails.vue?vue&type=template&id=2cd7bbca&scoped=true&"
import script from "./appInfoDetails.vue?vue&type=script&lang=js&"
export * from "./appInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./appInfoDetails.vue?vue&type=style&index=0&id=2cd7bbca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd7bbca",
  null
  
)

export default component.exports